import styled from "styled-components";

export const SwitchWrapper = styled.div`
  .switch-button {
    width: 100%;
  }

  .switch-button__item {
    width: 50%;
  }
  padding-bottom: 20px;
`;
